import React from "react";
import "./Item.css";
import { items } from "../itemsDB.js";
import { Button, Modal } from "antd";
import { useState } from "react";
import { Link } from "react-router-dom";

function Item(props) {
  //   const [isModalVisible, setModalVisible] = useState(false);

  return (
    <>
      <div className="item">
        <h2 className="item__name">{props.name}</h2>
        <p className="item__details">{props.details}</p>
        <div className="item__bottom-flex">
          <Button
            className="item__button"
            // onClick={() => setModalVisible(true)}
          >
            Buy for ${props.button}
          </Button>
          {/* <Link to="/product" state={e} className="login">
            Go to Page
          </Link> */}
          <a href="mailto:enriqueiturriagaa@gmail.com">Questions?</a>
        </div>
      </div>
    </>
  );
}

export default Item;
